import React from "react";
import { LogOut, RefreshCw, Loader2 } from "lucide-react";

/**
 * Common admin header bar with brand + nav links + optional refresh + logout.
 *
 * @param {string} title - main heading (Merriweather)
 * @param {string} subtitle - secondary line (slate)
 * @param {React.ReactNode} icon - icon shown in left badge
 * @param {Array<{label:string, href:string, testid?:string}>} navLinks
 * @param {() => void} onRefresh - if supplied, renders refresh button
 * @param {boolean} refreshing
 * @param {() => void} onLogout
 */
export default function AdminHeader({ title, subtitle, icon, navLinks = [], onRefresh, refreshing = false, onLogout }) {
  return (
    <header className="border-b" style={{ background: "var(--np-primary)", borderColor: "rgba(255,255,255,0.08)" }}>
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          {icon && <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: "var(--np-tension)" }}>{icon}</div>}
          <div>
            <p className="text-white text-lg leading-tight" style={{ fontFamily: "Merriweather, serif" }}>{title}</p>
            {subtitle && <p className="text-xs" style={{ color: "rgba(255,255,255,0.6)" }}>{subtitle}</p>}
          </div>
        </div>
        <div className="flex items-center gap-2 flex-wrap justify-end">
          {navLinks.map((l) => (
            <a key={l.href} href={l.href} data-testid={l.testid}
              className="text-xs px-3 py-2 rounded-full border border-white/15 text-white hover:bg-white/10">
              {l.label}
            </a>
          ))}
          {onRefresh && (
            <button type="button" onClick={onRefresh} disabled={refreshing} data-testid="admin-refresh-btn"
              className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full text-sm font-medium text-white border border-white/15 hover:bg-white/10 transition disabled:opacity-60">
              {refreshing ? <Loader2 size={15} className="animate-spin" /> : <RefreshCw size={15} />}
              <span className="hidden sm:inline">Aggiorna</span>
            </button>
          )}
          {onLogout && (
            <button type="button" onClick={onLogout} data-testid="admin-logout-btn"
              className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full text-sm font-medium text-white border border-white/15 hover:bg-white/10 transition">
              <LogOut size={15} /><span className="hidden sm:inline">Esci</span>
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
